var map = {
	"./administrations/administrations.module": [
		"./src/app/administrations/administrations.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"administrations-administrations-module"
	],
	"./alergenos/alergenos.module": [
		"./src/app/alergenos/alergenos.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"alergenos-alergenos-module"
	],
	"./caracteristicaslocales/caracteristicaslocales.module": [
		"./src/app/caracteristicaslocales/caracteristicaslocales.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"caracteristicaslocales-caracteristicaslocales-module"
	],
	"./cartacategorias/cartacategorias.module": [
		"./src/app/cartacategorias/cartacategorias.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"cartacategorias-cartacategorias-module"
	],
	"./cartas/cartas.module": [
		"./src/app/cartas/cartas.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"default~cartas-cartas-module~distritos-distritos-module~encuestas-encuesta-module~events-events-modu~a2bddf9b",
		"cartas-cartas-module"
	],
	"./categorias/categorias.module": [
		"./src/app/categorias/categorias.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"categorias-categorias-module"
	],
	"./categoriasayuda/categoriasayuda.module": [
		"./src/app/categoriasayuda/categoriasayuda.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"categoriasayuda-categoriasayuda-module"
	],
	"./configuraciones/configuraciones.module": [
		"./src/app/configuraciones/configuraciones.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"configuraciones-configuraciones-module"
	],
	"./cupones/cupones.module": [
		"./src/app/cupones/cupones.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"cupones-cupones-module"
	],
	"./customers/customers.module": [
		"./src/app/customers/customers.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"customers-customers-module"
	],
	"./distritos/distritos.module": [
		"./src/app/distritos/distritos.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"default~cartas-cartas-module~distritos-distritos-module~encuestas-encuesta-module~events-events-modu~a2bddf9b",
		"distritos-distritos-module"
	],
	"./encuestas/encuesta.module": [
		"./src/app/encuestas/encuesta.module.ts",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~cartas-cartas-module~distritos-distritos-module~encuestas-encuesta-module~events-events-modu~a2bddf9b",
		"encuestas-encuesta-module"
	],
	"./estadosolicitudes/estadosolicitudes.module": [
		"./src/app/estadosolicitudes/estadosolicitudes.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"estadosolicitudes-estadosolicitudes-module"
	],
	"./events/events.module": [
		"./src/app/events/events.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"default~cartas-cartas-module~distritos-distritos-module~encuestas-encuesta-module~events-events-modu~a2bddf9b",
		"events-events-module"
	],
	"./gestorerrores/gestorerrores.module": [
		"./src/app/gestorerrores/gestorerrores.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"gestorerrores-gestorerrores-module"
	],
	"./groupscustomers/groupscustomers.module": [
		"./src/app/groupscustomers/groupscustomers.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"groupscustomers-groupscustomers-module"
	],
	"./idiomas/idiomas.module": [
		"./src/app/idiomas/idiomas.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"idiomas-idiomas-module"
	],
	"./invitaciones/invitaciones.module": [
		"./src/app/invitaciones/invitaciones.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"invitaciones-invitaciones-module"
	],
	"./locals/locals.module": [
		"./src/app/locals/locals.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"default~cartas-cartas-module~distritos-distritos-module~encuestas-encuesta-module~events-events-modu~a2bddf9b",
		"locals-locals-module"
	],
	"./mypromos/mypromos.module": [
		"./src/app/mypromos/mypromos.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"mypromos-mypromos-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"pages-pages-module"
	],
	"./patrocinadores-rutas/patrocinadores-rutas.module": [
		"./src/app/patrocinadores-rutas/patrocinadores-rutas.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"patrocinadores-rutas-patrocinadores-rutas-module"
	],
	"./patrocinadores/patrocinadores.module": [
		"./src/app/patrocinadores/patrocinadores.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"patrocinadores-patrocinadores-module"
	],
	"./preferences/preferences.module": [
		"./src/app/preferences/preferences.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"preferences-preferences-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"profile-profile-module"
	],
	"./promos/promos.module": [
		"./src/app/promos/promos.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"promos-promos-module"
	],
	"./puntosinformacion/puntosinformacion.module": [
		"./src/app/puntosinformacion/puntosinformacion.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"puntosinformacion-puntosinformacion-module"
	],
	"./questions/questions.module": [
		"./src/app/questions/questions.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"questions-questions-module"
	],
	"./roles/roles.module": [
		"./src/app/roles/roles.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"roles-roles-module"
	],
	"./rutas/rutas.module": [
		"./src/app/rutas/rutas.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"default~cartas-cartas-module~distritos-distritos-module~encuestas-encuesta-module~events-events-modu~a2bddf9b",
		"rutas-rutas-module"
	],
	"./rutaseditores/rutas-editor.module": [
		"./src/app/rutaseditores/rutas-editor.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"rutaseditores-rutas-editor-module"
	],
	"./soportes/soportes.module": [
		"./src/app/soportes/soportes.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~12081a7e",
		"default~administrations-administrations-module~cartas-cartas-module~distritos-distritos-module~event~bd695518",
		"default~cartas-cartas-module~distritos-distritos-module~encuestas-encuesta-module~events-events-modu~a2bddf9b",
		"soportes-soportes-module"
	],
	"./starter/starter.module": [
		"./src/app/starter/starter.module.ts",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"starter-starter-module"
	],
	"./stats/stats.module": [
		"./src/app/stats/stats.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"stats-stats-module"
	],
	"./tareas/tareas.module": [
		"./src/app/tareas/tareas.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"tareas-tareas-module"
	],
	"./textoslegales/textoslegales.module": [
		"./src/app/textoslegales/textoslegales.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~3241ca77",
		"textoslegales-textoslegales-module"
	],
	"./tiposoportes/tiposoportes.module": [
		"./src/app/tiposoportes/tiposoportes.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"tiposoportes-tiposoportes-module"
	],
	"./tipospromos/tipospromos.module": [
		"./src/app/tipospromos/tipospromos.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"tipospromos-tipospromos-module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"default~administrations-administrations-module~cartas-cartas-module~customers-customers-module~distr~67297e85",
		"users-users-module"
	],
	"./usersdemo/usersdemo.module": [
		"./src/app/usersdemo/usersdemo.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"usersdemo-usersdemo-module"
	],
	"./usersstaffs/usersstaffs.module": [
		"./src/app/usersstaffs/usersstaffs.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"usersstaffs-usersstaffs-module"
	],
	"./videos/videos.module": [
		"./src/app/videos/videos.module.ts",
		"default~administrations-administrations-module~alergenos-alergenos-module~caracteristicaslocales-car~db947130",
		"videos-videos-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;